const updateService = (state, action) => {
  if(state===undefined){
    return {
      Api: undefined,
      User: undefined,
      Directory: undefined,
      Route: undefined,
      Geozone: undefined,
    }
  }

  const { service:data } = state

  switch(action.type){
    case 'SET_SERVICE_API':
      return {...data, Api:action.payload};
    case 'SET_SERVICE_USER':
      return {...data, User:action.payload};
    case 'SET_SERVICE_DIRECTORY':
      return {...data, Directory:action.payload};
    case 'SET_SERVICE_ROUTE':
      return {...data, Route:action.payload};
    case 'SET_SERVICE_GEOZONE':
      return {...data, Geozone:action.payload};

    default:
      return data;
  }
}

export default updateService;
